import { render } from "./CoreValues.vue?vue&type=template&id=79242d60&scoped=true"
import script from "./CoreValues.vue?vue&type=script&lang=js"
export * from "./CoreValues.vue?vue&type=script&lang=js"

import "./CoreValues.vue?vue&type=style&index=0&id=79242d60&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79242d60"]])

export default __exports__